import { ActionContext } from 'vuex';
import { Nullable } from '@jamesgmarks/utilities';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { IBillingInternalNotePayloadData, IBillingProfile, INoteComment } from '@/shared/interfaces/billing-profile';
import { IModifyPayload } from '@/shared/interfaces/modify-payload';
import { IApiResponse, IMetaResponse } from '@/shared';

type TBillingProfileState = {
  single: IBillingProfile
};

export default {
  namespaced: true, // 'billing-profile/'

  state: {
    single: {},
  },

  getters: {
    single(state: TBillingProfileState): IBillingProfile {
      return state.single ?? <IBillingProfile>{};
    },
  },

  mutations: {
    setBillingProfile(state: TBillingProfileState, payload: IApiResponse<IBillingProfile, IMetaResponse>) {
      state.single = payload.data ?? <IBillingProfile>{};
    },
  },

  actions: {
    async getBillingProfile(ctx: ActionContext<TBillingProfileState, any>, payload: {freshbooksClientId: number}) {
      const result = await adminRequest.get<IBillingProfile>(`/billing-api/accounts/${payload.freshbooksClientId}/billing_profile`);
      ctx.commit('setBillingProfile', result);
    },
    /**
     * payload.id referes to the freshbooks client id
     */
    async updateBillingProfile(ctx: ActionContext<TBillingProfileState, any>, payload: IModifyPayload<number, Partial<IBillingProfile>>) {
      const result = await adminRequest.put<Partial<IBillingProfile>>(`/billing-api/accounts/${payload.id}/billing_profile`, payload.data);
      ctx.commit('setBillingProfile', result);
    },
  },
};
